const sleep_stages_probablity_chart_options = ({data
    // , categories
}) => ({
    data,
    chart: {
        // type: 'heatmap',
        margin: [60, 10, 80, 50]
    },

    boost: {
        useGPUTranslations: true
    },

    title: {
        text: 'Sleep Stage Probablity',
        align: 'left',
        x: 40
    },

    subtitle: {
        text: "To scroll, hold 'alt'. Then hit `mouse-right-click` and move mouse",
        align: 'left',
        x: 40
    },

    xAxis: {
        // type: 'datetime',
        min: Date.UTC(2017, 0, 1),
        max: Date.UTC(2017, 11, 31, 23, 59, 59),
        labels: {
            align: 'left',
            x: 5,
            y: 14,
            format: '{value:%B}' // long month
        },
        showLastLabel: false,
        tickLength: 16
    },

    yAxis: {
        title: {
            text: null
        },
        minPadding: 0,
        maxPadding: 0,
        startOnTick: false,
        endOnTick: false,
        tickPositions: [.2,.4,.6,.8,1],
        tickWidth: 1,
        min: 0,
        max: 1,
        reversed: false
    },

    colorAxis: {
        stops: [
            [0, '#3060cf'],
            [0.25, '#fffbbc'],
            [0.9, '#c4463a'],
            [1, '#c4463a']
        ],
        min: 0,
        max: 1,
        startOnTick: false,
        endOnTick: false
    },

    series: [{
        data: [["5/7/2019", 0, 3204832]],
        boostThreshold: 100,
        borderWidth: 0,
        nullColor: '#EFEFEF',
        colsize: 24 * 36e5, // one day
        tooltip: {
            headerFormat: 'Probablity<br/>',
            pointFormat: '{point.x:%e %b, %Y} {point.y}:00: <b>{point.value} ℃</b>'
        },
        turboThreshold: Number.MAX_VALUE // #3404, remove after 4.0.5 release
    }]

});

  export default sleep_stages_probablity_chart_options;